(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-gallery-thumb]'));
      if (!thumbs.length) return;

      var mainImg = gallery.querySelector('[data-product-gallery-main]');
      var counter = gallery.querySelector('[data-product-gallery-counter-text]');
      var viewport = gallery.querySelector('[data-product-gallery-viewport]');
      var counterTemplate = counter ? counter.getAttribute('data-counter-template') : '';
      var currentIndex = 0;

      function goTo(index) {
        if (index < 0) index = thumbs.length - 1;
        if (index >= thumbs.length) index = 0;
        currentIndex = index;
        var thumb = thumbs[index];
        if (mainImg) {
          mainImg.src = thumb.getAttribute('data-full-src');
          mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
        }
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        if (counter && counterTemplate) {
          counter.textContent = counterTemplate
            .replace('CURRENT', String(index + 1))
            .replace('TOTAL', String(thumbs.length));
        }
        if (thumb.scrollIntoView) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goTo(i);
        });
      });

      var prevBtn = gallery.querySelector('[data-product-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-product-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

      if (viewport) {
        var touchStartX = null;
        viewport.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        viewport.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var deltaX = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(deltaX) > 40) {
            if (deltaX < 0) {
              goTo(currentIndex + 1);
            } else {
              goTo(currentIndex - 1);
            }
          }
          touchStartX = null;
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
